module.exports = __webpack_public_path__ + "img/carousel2.cb1e3379.jpg";